import { GodziDropSection } from '@funkygame/godzidrop-section'
import { useState } from 'react'
import { authRepository } from '../../domain/consumePlayer/repository/AuthRepository'
import { language } from '../../domain/language/languageUtil'
import { getShortLang, getApiEndpointFullyQualifiedDomain, shortlanguageList } from '../../util'

interface GodziDropDashBoardProps {
  onClose: () => void
  isShowDashboard: boolean
}
function getUrl() {
  return `https://${getApiEndpointFullyQualifiedDomain()}`
}
export const GodziDropDashBoard = (props: GodziDropDashBoardProps) => {
  const [isShowCountdown, setIsShowCountdown] = useState(true)

  if (!props.isShowDashboard) return null

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%', position: 'absolute' }}>
      <GodziDropSection
        locale={getShortLang(shortlanguageList, language)}
        authToken={authRepository.getAuth()}
        host={getUrl()}
        isOpen={props.isShowDashboard}
        onClose={() => {
          props.onClose()
          setIsShowCountdown(false)
        }}
        isShowCountdown={isShowCountdown}
      />
    </div>
  )
}
